import ActionStrip from 'components/ModeStrip/Strip';
import RedoButton from '../../RedoButton';
import UndoButton from '../../UndoButton';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { undoEditFacetState, redoEditFacetState } from 'store/slices/ToolSlice';
import { useEffect } from 'react';

export default function DeleteFacetsStrip() {
	const dispatch = useDispatch();
	const { currentIndex, history } = useSelector((state: RootState) => state.toolNewPostions.data.facetHistory.deleteFacet);
	const disableRedoBtn = (currentIndex >= history.length - 1);
	const disableUndoBtn = (currentIndex < 0);

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (!(e.ctrlKey || e.metaKey)) return;
			const key = e.key.toLowerCase();
			if (key === 'z' && !e.shiftKey) {
				e.preventDefault();
				dispatch(undoEditFacetState());
			} else if (key === 'y' || (key === 'z' && e.shiftKey)) {
				e.preventDefault();
				dispatch(redoEditFacetState());
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [dispatch]);

	return (
		<ActionStrip
			icon={<svg width="21" height="22.91" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8.5 10.7778V18.1111M13.5 10.7778V18.1111M1 5.88889H21M19.75 5.88889L18.6662 20.7291C18.6214 21.3458 
						18.3391 21.923 17.8764 22.3444C17.4137 22.7657 16.8048 23 16.1725 23H5.8275C5.19517 23 4.58633 22.7657 4.12361 
						22.3444C3.66088 21.923 3.37865 21.3458 3.33375 20.7291L2.25 5.88889H19.75ZM14.75 5.88889V2.22222C14.75 1.89807 
						14.6183 1.58719 14.3839 1.35798C14.1495 1.12877 13.8315 1 13.5 1H8.5C8.16848 1 7.85054 1.12877 7.61612 1.35798C7.3817 
						1.58719 7.25 1.89807 7.25 2.22222V5.88889H14.75Z"
				stroke='var(--defaultIconColor)'
				strokeWidth="1.60573"
				strokeLinecap="round"
				strokeLinejoin="round" />
			</svg>}
			action="Delete Facets">
			<UndoButton id="delete-facet-undo"
				className="no-left-border"
				onClick={() => dispatch(undoEditFacetState())}
				disabled={disableUndoBtn}
			/>
			<RedoButton id="delete-facet-redo"
				disabled={disableRedoBtn}
				onClick={() => dispatch(redoEditFacetState())}
			/>
		</ActionStrip>
	);
}